module.exports = __webpack_public_path__ + "media/images/new_home/sponsor-logo-5-a1df23ffbe1625924488c247403c4084.png";